import { createRoot } from 'react-dom/client'
import './index.css'
import './animations.css'
import useIntersectionObserver from './hooks/useIntersectionProvider.tsx'
import type { ReactNode } from 'react'
import { ThemeProvider } from './providers/ThemeProvider.tsx'
import { theme } from './theme.ts'
import { RouterProvider } from 'react-router'
import { router } from './router.tsx'

const ThemeWrapper = ({ children }: { children: ReactNode }) => {

  useIntersectionObserver("slideOut", "slideIn", 0.4);
  useIntersectionObserver("fadeOut", "fadeIn", 0.4);
  useIntersectionObserver("slideLeftOut", "slideLeftIn", 0.4);
  useIntersectionObserver("slideLeftOut2", "slideLeftIn2", 0.4);
  useIntersectionObserver("slideRightOut", "slideRightIn", 0.4);
  useIntersectionObserver("slideTopOut", "slideTopIn", 0.4);
  useIntersectionObserver("slideBottomOut", "slideBottomIn", 0.4);
  useIntersectionObserver("scaleOut", "scaleIn", 0.4);
  useIntersectionObserver("rotateOut", "rotateIn", 0.4);
  useIntersectionObserver("flipOut", "flipIn", 0.4);
  useIntersectionObserver("zoomOut", "zoomIn", 0.4);
  useIntersectionObserver("bounceOut", "bounceIn", 0.4);
  useIntersectionObserver("swingOut", "swingIn", 0.4);
  useIntersectionObserver("rollOut", "rollIn", 0.4);
  useIntersectionObserver("skewOut", "skewIn", 0.4);
  useIntersectionObserver("wobbleOut", "wobbleIn", 0.4);
  useIntersectionObserver("pulseOut", "pulseIn", 0.4);
  useIntersectionObserver("shakeOut", "shakeIn", 0.4);
  useIntersectionObserver("blurOut", "blurIn", 0.4);
  useIntersectionObserver("expandOut", "expandIn", 0.4);
  useIntersectionObserver("contractOut", "contractIn", 0.4);

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <ThemeWrapper>
    <RouterProvider router={router} />
  </ThemeWrapper>
)
